import { Breakpoint, Color } from '@elearning-platform/ui';
import { styled } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

export const FormContainer = styled.form``;

export const FormInnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  padding: 0 16px;
  margin-bottom: 40px;
  
  @media ${Breakpoint.SmallDesktop} {
    padding: 20px 40px 0 40px;
  }
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;

  @media ${Breakpoint.SmallDesktop} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

export const FullWidthField = styled.div`
  grid-column: 1 / -1;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  border-top: 1px solid ${Color.Gray300};
  padding: 28px 16px;

  @media ${Breakpoint.SmallDesktop} {
    flex-direction: row;
    gap: 28px;
    padding: 40px;
  }
`;
